import { TARGET_THRESHOLD, BAD_THRESHOLD } from '../constants/thresholds';
import { Colors } from '@/common/colors/colors';

export const getColor = (score) => {
    if (score >= TARGET_THRESHOLD) {
        return Colors.green;
    }
    if (score >= BAD_THRESHOLD) {
        return Colors.orange;
    }
    return Colors.red;
}